import {
  HeartPulse,
  Feather,
  PawPrint,
  UsersRound,
  Atom,
  LibraryBig,
  MoonStar,
  MonitorCog,
  Flower2,
  Pi,
  Earth,
  BookA,
  HandCoins,
  FlaskConical,
  BookOpenCheck,
  Bike,
} from "lucide-react";

const CategoryIcon = ({ emojiName, strokeWidth = 1, size = 16 }) => {
  const icons = {
    HeartPulse: HeartPulse,
    Feather: Feather,
    PawPrint: PawPrint,
    UsersRound: UsersRound,
    Atom: Atom,
    LibraryBig: LibraryBig,
    MoonStar: MoonStar,
    MonitorCog: MonitorCog,
    Gamepad2: Bike,
    Flower2: Flower2,
    Pi: Pi,
    Earth: Earth,
    BookA: BookA,
    HandCoins: HandCoins,
    FlaskConical: FlaskConical,
    BookOpenCheck: BookOpenCheck,
  };

  const IconComponent = icons[emojiName];

  return (
    <div className="text-[16px]">
      {IconComponent ? (
        <IconComponent strokeWidth={strokeWidth} size={size} />
      ) : null}
    </div>
  );
};

export default CategoryIcon;
